<div class="d-flex justify-content-between align-items-center w-100 mb-2">
	<h3 class="m-0">Komentarze do terminu (BAG {{ data.reservationId }})</h3>
	<i (click)="dialogRef.close()" role="button" class="fas fa-times fs-2"></i>
</div>
<app-note-list [view]="'summary'" [tableName]="TableName.PAYMENT_TERM" [tableId]="data.paymentTermId"></app-note-list>
